export default '/pricing/security';
